import { ContactWindow } from "@/components/contacts/ContactWindow";
import { contactsFilterCategory } from "@/data/filters/categories/contacts";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/contacts",
)({
  component: RouteComponent,
  loader: () => ({
    crumb: contactsFilterCategory.title,
  }),
});

function RouteComponent() {
  const { useAdvancedConfiguration } = Route.useRouteContext();
  const navigate = Route.useNavigate();

  const [configuration, setConfiguration] = useAdvancedConfiguration();
  return (
    <ContactWindow
      configuration={configuration}
      onDoneUpdating={() => navigate({ to: "/campaigns/$id/define/advanced" })}
      setConfiguration={setConfiguration}
    />
  );
}
